/**
 * 共通フォームルートコンポーネント
 * オペレーションパッケージのタイプに応じて適切なフォームコンポーネントを表示する
 *
 * - approvalInfoがある場合: RequestTaskDetailPageContentを使用した承認フォーム
 * - DeviceInventoryパッケージ: 専用のDeviceInventoryFormContainerを使用
 * - その他のパッケージ: 標準のFormContainerを使用
 */
import { createFileRoute } from '@tanstack/react-router';
import { useCallback } from 'react';

import { ViewportLoader } from '@/components/Loading/ViewportLoader';

import { useFormState } from '../../../-hooks/useFormState';
import { useGetSelfServiceTaskForm } from '../../../-query';
import { FormPackageContainer } from '../../../../-components/form-factory';
import { FormWithApprovalContainer } from '../../../../-components/form-factory/FormWithApprovalContainer';
import { useGetSelfServiceTask } from '../../../../-query';

export const Route = createFileRoute(
  '/_individual/individual/task/$id/_operation-package/_common/form/$formId/',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id: taskId, formId: operationTaskInstanceId } = Route.useParams();
  const navigate = Route.useNavigate();

  // タスク情報からオペレーションタイプを取得
  const { data: taskData, isLoading: isTaskLoading } =
    useGetSelfServiceTask(taskId);
  const { data, isLoading } = useGetSelfServiceTaskForm(
    taskId,
    operationTaskInstanceId,
  );

  useFormState();

  const handleNavigateBack = useCallback(() => {
    navigate({ to: `/individual/task/${taskId}` });
  }, [navigate, taskId]);

  if (isLoading || isTaskLoading) {
    return <ViewportLoader />;
  }

  if (!data || !taskData) {
    return null;
  }

  // approvalInfoがある場合は承認フォームを表示
  const hasApprovalInfo = 'approvalInfo' in data && data.approvalInfo != null;

  if (hasApprovalInfo) {
    return (
      <FormWithApprovalContainer
        taskId={taskId}
        operationTaskInstanceId={operationTaskInstanceId}
        onNavigateBack={handleNavigateBack}
        formData={data}
        operationType={taskData.operationType}
      />
    );
  }

  // 通常のフォーム: パッケージタイプに応じて適切なフォームコンポーネントを使用
  return (
    <FormPackageContainer
      operationType={taskData.operationType}
      taskId={taskId}
      operationTaskInstanceId={operationTaskInstanceId}
      onNavigateBack={handleNavigateBack}
      formData={data}
    />
  );
}
